import KeyMirror from 'keymirror';

export default KeyMirror({
    UPDATE_LANGUAGE: true,
});
